// @mui
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
// hooks
// components
import Page from '../../components/Page';
// sections
import { RadioButtonCheckedTwoTone, RadioButtonUncheckedTwoTone } from '@mui/icons-material';
import Box from '@mui/material/Box';
import { get } from 'lodash';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getExamDetailsFromCode, postQrExamAnswer } from '../../axiosLib/services/exam/user';
import { getUserLevel } from '../../axiosLib/services/institution/user';
import { examSetList } from '../../util/helpers';

const commonStyles = {
  bgcolor: 'background.paper',
  borderColor: 'text.primary',
  m: 1,
  border: 3,
  width: '3rem',
  height: '3rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  cursor: 'pointer', // Cursor changes to pointer on hover
  '&:hover': {
    backgroundColor: '#1565c0', // Darker background on hover
  },
};

export default function UserCheckFilledAnswersMobileOmr() {
  const navigate = useNavigate();

  const [checkedItems, setCheckedItems] = useState([]);
  const [examDetails, setExamDetails] = useState({});
  const [examMetaData, setExamMetaData] = useState({});
  const [userData, setUserData] = useState({});
  const [showLoader, setShowLoader] = useState(false);

  const getExamCode = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    return urlParams.get('examCode');
  };

  const handleChange = (index) => (event) => {
    const updatedCheckedItems = [...checkedItems];
    updatedCheckedItems[index] = event.target.checked; // Update specific checkbox
    setCheckedItems(updatedCheckedItems);

    // console.log(updatedCheckedItems);
  };

  const handlePublishAnswer = () => {
    // setShowLoader(true);

    let mcqPostData = {
      mcqAnswers: checkedItems,
      metaData: examMetaData,
      examCode: getExamCode(),
    };

    console.log(mcqPostData);

    postQrExamAnswer(mcqPostData, (err, data) => {
      if (!err) {
        navigate('/user/afterSubmit?examId=' + get(examDetails, '_id'), { replace: true });
      }
    });
  };

  const resultData = () => {
    const examCode = getExamCode();
    const storedItems = sessionStorage.getItem('cItm:' + examCode);

    getExamDetailsFromCode(examCode, (err, data) => {
      if (!err) {
        setExamDetails(data);
      }
    });

    getUserLevel((error, data) => {
      if (!error) {
        setUserData(get(data, 'user'));
      } else {
        console.log(error);
      }
    });

    if (storedItems) {
      console.log('Retrieved checked items from sessionStorage:', JSON.parse(storedItems));
      const {mcq, ...rest} = JSON.parse(storedItems);

      setExamMetaData(rest);

      setCheckedItems(mcq);
    } else {
      navigate('/user/mobileOmrScan?examCode=' + examCode);
    }
  };

  const renderCheckboxRows = () => {
    const rows = [];

    for (let i = 0; i < checkedItems.length; i += 4) {
      const rowItems = checkedItems.slice(i, i + 4); // Get 4 items per row

      rows.push(
        <Box
          key={i}
          sx={{
            border: '4px solid #ccc', // Box border
            borderRadius: '8px', // Rounded corners
            padding: '8px', // Spacing inside the box
            marginBottom: '16px', // Space between rows
            backgroundColor: '#f9f9f9', // Light background color
          }}
        >
          <Stack key={i} direction="row" alignItems="center">
            {/* Serial Number */}
            <div style={{ marginRight: '1.5rem', fontWeight: 'bold' }}>{Math.floor(i / 4) + 1}.</div>

            {/* Row of Checkboxes */}
            {rowItems.map((checked, index) => (
              <Stack direction={{ xs: 'column', sm: 'row' }} sx={{ width: '100%' }}>
                <Box
                  key={i + index}
                  sx={{
                    border: '1px solid #ccc',
                    width: '100%',
                    flexGrow: 1, // Allows equal space for all boxes
                    display: 'flex', // Enables content alignment
                    justifyContent: 'center', // Centers content horizontally
                    alignItems: 'center', // Centers content vertically
                  }}
                >
                  <span style={{ margin: 0 }}>{String.fromCharCode(((i + index) % 4) + 65)}</span> {/* Label */}
                  <Checkbox
                    key={index}
                    checked={checked}
                    onChange={handleChange(i + index)}
                    icon={<RadioButtonUncheckedTwoTone />} // Unchecked state
                    checkedIcon={<RadioButtonCheckedTwoTone />} // Checked state
                    sx={{ margin: 0 }}
                  />
                </Box>
              </Stack>
            ))}
          </Stack>
        </Box>
      );
    }
    return rows;
  };

  useEffect(() => {
    resultData();
  }, []);

  return (
    <Page title="Exam Result Check">
      <Container maxWidth="xl" sx={{ paddingTop: '20px', paddingBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <Card sx={{ width: '98%', marginBottom: '30px', border: '2px solid #800000' }}>
            <CardContent style={{ backgroundColor: 'beige', color: '#800000', fontWeight: 'bold', fontSize: '20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <Typography variant="h3">Student Name: {get(userData, 'username', '')}</Typography>
                <Typography variant="h5">{`Roll: ${get(userData, 'roll', '')}`}</Typography>
                <Typography variant="h5">{`Phone: ${get(userData, 'phone', '')}`}</Typography>
              </div>
            </CardContent>
          </Card>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <Card sx={{ width: '98%', marginBottom: '30px', border: '2px solid #800000' }}>
            <CardContent style={{ backgroundColor: 'beige', color: '#800000', fontWeight: 'bold', fontSize: '20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <Typography variant="h2">Exam Details</Typography>
                <Typography variant="h3">{get(examDetails, 'name', '')}</Typography>
                <Typography variant="h5">{`Exam Code: ${get(examDetails, 'code', '')}`}</Typography>
                <Typography variant="h5">{`Exam Set: ${get(examMetaData, 'examSet', '')}`}</Typography>
                <Typography variant="h5">{`Total Questions: ${get(examDetails, 'numberOfQuestions', '')}`}</Typography>
                <Typography variant="h5">{`Negative Marks/Question: ${get(
                  examDetails,
                  'negativeMarks',
                  ''
                )}`}</Typography>
              </div>
            </CardContent>
          </Card>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <Card sx={{ width: '98%', marginBottom: '30px', border: '2px solid #800000' }}>
            <CardContent style={{ backgroundColor: 'beige', color: '#800000', fontWeight: 'bold', fontSize: '20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <Typography variant="h3">{`Exam Set: ${get(examMetaData, 'examSet', '')}`}</Typography>
              </div>
            </CardContent>
          </Card>
        </div>

        <div>{renderCheckboxRows()}</div>


        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
          {showLoader ? (
            <CircularProgress color="inherit" />
          ) : (
            <Button
              style={{ backgroundColor: '#800000', color: 'white', padding: '10px 40px' }}
              onClick={() => {
                handlePublishAnswer();
              }}
            >
              Finish Exam
            </Button>
          )}
        </div>
      </Container>
    </Page>
  );
}
